import apiService from "./apiService";
import AppConstants from "../appConstants";

class SendpushService {
    getall(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_SENDPUSH, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    // report(params) {
    //     return new Promise((resolve, reject) => {
    //         apiService.downloadFile(AppConstants.URL_SENDPUSH_REPORT, params)
    //             .then(response => resolve(response))
    //             .catch(error => reject(error));
    //     });
    // }
    
    // =====================================================================
    
}

export default new SendpushService();
